module.exports = __webpack_public_path__ + "static/fipcelephantstar-1c8ecf51996acced7a3d2a1c9bdfdc74.jpeg";